import { useRef, useEffect, useState } from "react";
import { useInView } from "framer-motion";
import { STATS } from "../data/site";
import { Reveal } from "./Reveal";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1600;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.floor(eased * value));
      if (p < 1) requestAnimationFrame(tick);
      else setN(value);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);
  return (
    <span ref={ref} className="font-head font-bold text-5xl sm:text-6xl lg:text-7xl text-gold-metallic tabular-nums">
      {n}{suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section id="why" className="relative py-24 sm:py-32 bg-[#0D0D0D]" data-testid="stats-section">
      <div className="container-lux">
        <Reveal>
          <p className="overline mb-3">Why Choose Us</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight max-w-3xl">
            A reputation <span className="text-gold-metallic">built roof by roof.</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 mt-14">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1} className="border-l border-white/10 pl-5">
              <Counter value={s.value} suffix={s.suffix} />
              <p className="mt-3 text-sm uppercase tracking-wider text-[#C8C8C8]">{s.label}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-12 flex flex-wrap gap-4">
          {["Fully Insured", "Free Quotations"].map((t) => (
            <span key={t} className="glass rounded-sm px-5 py-2 text-sm text-[#F8F8F8]">{t}</span>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
